import ExportsFormatter from '../../../use/ExportsFormatter';

export default {
  toggleDropdown() {
    this.$refs.myDropdown.show();
  },
  downloadFiles(format) {
    if (this.rows.length) {
      this.downloadExportRows(format);
    } else {
      this.$root.$emit('downloadExport', this.columns, format);
    }
  },

  // descarga de documento
  async downloadExportRows(format) {
    try {
      this.loading = true;
      const uuidListSelected = this.rows.map(x => x.uuid);
      const payload = {
        section: `${this.$route.name}__${this.$moment(new Date()).format('DD_MM_YYYY_HH_mm')}`,
        cfg: {
          params: {
            $filter: JSON.stringify({
              uuid: [{ eq: JSON.stringify(uuidListSelected) }]
            }),
            $limit: 999999999
          }
        },
        sort: this.orderby || 'uuid'
      };
      if (this.$route.query['modifications-monitor']) {
        payload.cfg.params['modifications-monitor'] = true;
      }
      const exportsFormatter = new ExportsFormatter(this);
      const res = await exportsFormatter.getData(payload);
      const entities = exportsFormatter.parseDataResponse(res, this.$route.name);
      const headers = this.columns.filter(x => x.name !== 'interveners').map(x => x.name);

      exportsFormatter.formatEntitiesFields(entities, headers);
      exportsFormatter.applyTranslations(headers, entities);

      const fileData = await exportsFormatter.generateFile(format, headers, entities);
      exportsFormatter.downloadFile(fileData, this.$route.name, format);

      await this.$root.$emit('addDownloadToList', { fileData, section: this.$route.name, format });
      this.loading = false;
      this.$root.$emit('deselectAllRows');
      this.$toast.success(`Exportación completada`, `Documento ${format} descargado con éxito.`);
      this.$toast.success(`Exportación completada`, `El documento se ha adjuntado a la lista de exportaciones.`);
    } catch (error) {
      console.error(error);
      this.loading = false;
      this.$root.$emit('deselectAllRows');
      this.$toast.error(`Error`, error);
    }
  }
};
